import React, { useEffect, useState } from 'react';
import { ChevronLeft, Share2, Phone, MessageCircle, MapPin, Bed, Bath, Ruler, ChevronRight, X, CheckCircle, Lock, TrendingUp } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
interface ProjectDetailPageProps {
  projectId: number;
  developerId: number;
  developerName: string;
  developerTier?: 'gold' | 'silver' | 'bronze' | 'free';
  onBack: () => void;
  onNetworkClick?: () => void;
  onInventoryClick?: () => void;
  onRMIClick?: () => void;
}
interface Unit {
  id: number;
  type: string;
  area: string;
  garden?: string;
  beds: number;
  baths: number;
  price: string;
}
export function ProjectDetailPage({
  projectId,
  developerId,
  developerName,
  developerTier = 'free',
  onBack,
  onNetworkClick,
  onInventoryClick,
  onRMIClick
}: ProjectDetailPageProps) {
  const [selectedUnitType, setSelectedUnitType] = useState('Apartment');
  const [showRMIModal, setShowRMIModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState<Unit | null>(null);
  const [rmiMessage, setRmiMessage] = useState('');
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showPaymentPlanModal, setShowPaymentPlanModal] = useState(false);
  const [selectedUnitForPlan, setSelectedUnitForPlan] = useState<Unit | null>(null);
  const [showLockedFeatureModal, setShowLockedFeatureModal] = useState(false);
  const [showLockedUnitsModal, setShowLockedUnitsModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showAccreditationRequestModal, setShowAccreditationRequestModal] = useState(false);
  const [accreditationMessage, setAccreditationMessage] = useState('');
  const [showAccreditationSuccessModal, setShowAccreditationSuccessModal] = useState(false);
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Mock project data
  const project = {
    name: 'Madinety',
    location: '2.5 KM from Cairo',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80', 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80', 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80', 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'],
    developer: {
      name: 'Nations of Sky Development',
      logo: 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
      tier: 'Gold Member'
    },
    agent: {
      name: 'Mohamed Hossam',
      title: 'Agent',
      avatar: 'https://cdn.magicpatterns.com/uploads/dmyzTWp4qVkkavD8xUDYZW/OIP.g0qYLq0G09unEJPan_GKvwHaHw.webp',
      phone: '+20 123 456 7890'
    },
    commission: {
      rate: '2%',
      incentive: '1%'
    },
    offers: {
      title: '10 Years Plan',
      downpayment: 'Downpayment 0%',
      installments: 'Equal Instalments'
    },
    paymentPlans: [{
      id: 1,
      duration: '10 Years',
      downpayment: 'Downpayment 0%',
      installments: 'Equal Instalments'
    }, {
      id: 2,
      duration: '10 Years',
      downpayment: 'Downpayment 0%',
      installments: 'Equal Instalments'
    }, {
      id: 3,
      duration: '10 Years',
      downpayment: 'Downpayment 0%',
      installments: 'Equal Instalments'
    }],
    unitTypes: ['Apartment', 'Penthouse', 'Villa', 'Penthouse'],
    units: [{
      id: 1,
      type: 'Apartment',
      area: '120 M2',
      garden: 'Garden 100m2',
      beds: 2,
      baths: 3,
      price: '1,334,000 EGP'
    }, {
      id: 2,
      type: 'Apartment',
      area: '120 M2',
      garden: 'Garden 100m2',
      beds: 2,
      baths: 3,
      price: '1,334,000 EGP'
    }, {
      id: 3,
      type: 'Apartment',
      area: '120 M2',
      garden: 'Garden 100m2',
      beds: 2,
      baths: 3,
      price: '1,334,000 EGP'
    }],
    description: `تحديد مكان كمرحلة استراتيجية الغرب من أجل المناطق يتطلع تتضمن. مثل كل كمرحلة استراتيجية الغرب من أجل المناطق يتطلع تتضمن. مثل كل كمرحلة استراتيجية الغرب من أجل المناطق يتطلع تتضمن. مثل كل كمرحلة استراتيجية الغرب من أجل المناطق يتطلع تتضمن. مثل كل كمرحلة استراتيجية الغرب من أجل المناطق يتطلع تتضمن.`,
    masterPlan: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
    amenities: [{
      icon: '🏊',
      name: 'Outdoor Pools'
    }, {
      icon: '🏃',
      name: 'Jogging Trail'
    }, {
      icon: '🚴',
      name: 'Bicycles Lanes'
    }, {
      icon: '🏊',
      name: 'Outdoor Pools'
    }, {
      icon: '🏃',
      name: 'Jogging Trail'
    }, {
      icon: '🚴',
      name: 'Bicycles Lanes'
    }]
  };
  const availableTags = ['Payment plan', 'Offer', 'Floor plan', 'Brochure', 'Site visit'];
  // Unit type summary for Bronze members
  const unitTypeSummary = [{
    type: 'Apartment',
    priceRange: '1,200,000 - 1,500,000 EGP',
    count: 45
  }, {
    type: 'Penthouse',
    priceRange: '2,500,000 - 3,200,000 EGP',
    count: 12
  }, {
    type: 'Villa',
    priceRange: '3,800,000 - 5,500,000 EGP',
    count: 8
  }];
  // Public unit types for free tier (no pricing)
  const publicUnitTypes = [{
    type: 'Apartment',
    features: '2-3 Bedrooms, Modern Design',
    count: 45
  }, {
    type: 'Penthouse',
    features: 'Luxury Living, Rooftop Access',
    count: 12
  }, {
    type: 'Villa',
    features: 'Private Garden, Spacious Layout',
    count: 8
  }];
  const handleSendRMI = (unit: Unit) => {
    setSelectedUnit(unit);
    setRmiMessage('I want more information about this unit');
    setSelectedTags([]);
    setShowRMIModal(true);
  };
  const toggleTag = (tag: string) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };
  const handleSubmitRMI = () => {
    // In a real app, this would send to backend
    console.log('Sending RMI:', {
      unit: selectedUnit,
      message: rmiMessage,
      tags: selectedTags
    });
    setShowRMIModal(false);
    setShowSuccessModal(true);
  };
  const handleCloseSuccess = () => {
    setShowSuccessModal(false);
    setSelectedUnit(null);
    setRmiMessage('');
    setSelectedTags([]);
  };
  const handleViewPaymentPlan = (unit: Unit) => {
    if (developerTier !== 'gold') {
      setShowLockedFeatureModal(true);
      return;
    }
    setSelectedUnitForPlan(unit);
    setShowPaymentPlanModal(true);
  };
  const handleSharePaymentPlan = () => {
    // In a real app, this would generate a shareable link or PDF
    alert('Payment plan shared via WhatsApp!');
  };
  return <div className="min-h-screen bg-neutral-bg pb-20 font-sans w-full" data-id="element-2351">
      <div className="w-full mx-auto bg-neutral-bg min-h-screen relative" data-id="element-2352">
        {/* Hero Image Slider */}
        <div className="relative h-96" data-id="element-2353">
          {/* Current Image */}
          <img src={project.images[currentImageIndex]} alt={project.name} className="w-full h-full object-cover" data-id="element-2354" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-2355"></div>

          {/* Header Buttons */}
          <div className="absolute top-0 left-0 right-0 px-6 py-6 safe-top flex items-center justify-between" data-id="element-2356">
            <button onClick={onBack} className="p-3 bg-white/95 backdrop-blur-sm text-neutral-text rounded-full shadow-lg hover:bg-white transition-colors" data-id="element-2357">
              <ChevronLeft className="w-6 h-6" data-id="element-2358" />
            </button>
          </div>

          {/* Navigation Arrows */}
          {project.images.length > 1 && <>
              <button onClick={() => setCurrentImageIndex((currentImageIndex - 1 + project.images.length) % project.images.length)} className="absolute left-4 top-1/2 -translate-y-1/2 p-2 bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:bg-white transition-colors" data-id="element-2359">
                <ChevronLeft className="w-5 h-5 text-neutral-text" data-id="element-2360" />
              </button>
              <button onClick={() => setCurrentImageIndex((currentImageIndex + 1) % project.images.length)} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:bg-white transition-colors" data-id="element-2361">
                <ChevronRight className="w-5 h-5 text-neutral-text" data-id="element-2362" />
              </button>
            </>}

          {/* Image Indicators */}
          {project.images.length > 1 && <div className="absolute bottom-20 left-0 right-0 flex justify-center gap-2" data-id="element-2363">
              {project.images.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`h-1.5 rounded-full transition-all ${index === currentImageIndex ? 'w-8 bg-white' : 'w-1.5 bg-white/50'}`} data-id="element-2364" />)}
            </div>}

          {/* Project Info Overlay */}
          <div className="absolute bottom-6 left-6 right-6" data-id="element-2365">
            <h1 className="text-4xl font-bold text-white mb-2" data-id="element-2366">
              {project.name}
            </h1>
            <div className="flex items-center gap-2 text-white/95" data-id="element-2367">
              <MapPin className="w-5 h-5" data-id="element-2368" />
              <span className="text-base" data-id="element-2369">{project.location}</span>
            </div>
          </div>
        </div>

        {/* Developer Header Card */}
        <div className="bg-white mx-6 -mt-8 rounded-2xl shadow-xl p-5 relative z-10 border border-gray-100" data-id="element-2370">
          <div className="flex items-center justify-between" data-id="element-2371">
            <div className="flex items-center gap-4" data-id="element-2372">
              <div className="w-16 h-16 bg-white rounded-xl border-2 border-gray-100 p-3 flex items-center justify-center shadow-sm" data-id="element-2373">
                <img src={project.developer.logo} alt={project.developer.name} className="w-full h-full object-contain" data-id="element-2374" />
              </div>
              <div data-id="element-2375">
                <h3 className="font-bold text-neutral-text text-base" data-id="element-2376">
                  {project.developer.name}
                </h3>
              </div>
            </div>
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-2377">
              {project.developer.tier}
            </span>
          </div>
        </div>

        {/* Share Project Button */}
        <div className="px-6 pt-6" data-id="element-2378">
          <button className="w-full bg-white border-2 border-secondary text-secondary font-bold py-4 rounded-xl hover:bg-secondary hover:text-white transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-2379">
            <Share2 className="w-5 h-5" data-id="element-2380" />
            Share Project
          </button>
        </div>

        {/* Agent Card */}
        <div className="mx-6 mt-6 bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-5 shadow-sm border border-teal-100" data-id="element-2381">
          <div className="flex items-center justify-between" data-id="element-2382">
            <div className="flex items-center gap-4" data-id="element-2383">
              <img src={project.agent.avatar} alt={project.agent.name} className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-2384" />
              <div data-id="element-2385">
                <p className="text-xs text-gray-600 mb-0.5" data-id="element-2386">
                  {project.agent.title}
                </p>
                <p className="font-bold text-neutral-text text-base" data-id="element-2387">
                  {project.agent.name}
                </p>
              </div>
            </div>
            <div className="flex gap-3" data-id="element-2388">
              <button className="p-3 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow" data-id="element-2389">
                <Phone className="w-5 h-5 text-gray-700" data-id="element-2390" />
              </button>
              <button className="p-3 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow" data-id="element-2391">
                <MessageCircle className="w-5 h-5 text-gray-700" data-id="element-2392" />
              </button>
              <button className="px-5 py-3 bg-primary text-white rounded-full font-bold text-sm hover:bg-primary-dark transition-colors shadow-sm" data-id="element-2393">
                Send RMI
              </button>
            </div>
          </div>
        </div>

        {/* Commission and Incentives */}
        <div className="px-6 pt-8" data-id="element-2394">
          <h3 className="text-lg font-bold text-neutral-text mb-4" data-id="element-2395">
            Commission and Incentives
          </h3>
          <div className="flex gap-3" data-id="element-2396">
            <div className="bg-secondary/10 border-2 border-secondary text-secondary font-bold px-5 py-3 rounded-xl text-sm" data-id="element-2397">
              {project.commission.rate} commission
            </div>
            <div className="bg-secondary/10 border-2 border-secondary text-secondary font-bold px-5 py-3 rounded-xl text-sm" data-id="element-2398">
              {project.commission.incentive} Incentive
            </div>
          </div>
        </div>

        {/* Offers */}
        <div className="px-6 pt-8" data-id="element-2399">
          <h3 className="text-lg font-bold text-neutral-text mb-4" data-id="element-2400">Offers %</h3>
          <div className="bg-gradient-to-br from-secondary to-secondary-dark text-white rounded-2xl p-6 shadow-lg" data-id="element-2401">
            <p className="text-xl font-bold mb-2" data-id="element-2402">{project.offers.title}</p>
            <p className="text-base opacity-95 mb-1" data-id="element-2403">
              {project.offers.downpayment}
            </p>
            <p className="text-base opacity-95" data-id="element-2404">
              {project.offers.installments}
            </p>
          </div>
        </div>

        {/* Original Payment Plans */}
        <div className="px-6 pt-8" data-id="element-2405">
          <h3 className="text-lg font-bold text-neutral-text mb-4" data-id="element-2406">
            Original Payment Plans
          </h3>
          <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2" data-id="element-2407">
            {project.paymentPlans.map(plan => <div key={plan.id} className="bg-white rounded-2xl p-5 border border-gray-200 min-w-[160px] flex-shrink-0 shadow-sm" data-id="element-2408">
                <p className="font-bold text-neutral-text mb-3 text-base" data-id="element-2409">
                  {plan.duration}
                </p>
                <p className="text-sm text-gray-600 mb-2" data-id="element-2410">{plan.downpayment}</p>
                <p className="text-sm text-gray-600" data-id="element-2411">{plan.installments}</p>
              </div>)}
          </div>
        </div>

        {/* Unit Types Filter */}
        <div className="px-6 pt-8" data-id="element-2412">
          <div className="flex gap-3 overflow-x-auto no-scrollbar" data-id="element-2413">
            {project.unitTypes.map((type, index) => <button key={index} onClick={() => setSelectedUnitType(type)} className={`px-5 py-3 rounded-xl text-sm font-bold transition-all whitespace-nowrap shadow-sm ${selectedUnitType === type ? 'bg-primary text-white' : 'bg-white text-gray-600 border-2 border-gray-200'}`} data-id="element-2414">
                {type}
              </button>)}
          </div>
        </div>

        {/* Units List - Different view based on tier */}
        {developerTier === 'free' ?
      // Free Tier View - Public Information Only (No Pricing)
      <div className="px-6 pt-5 space-y-4" data-id="element-2415">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-2xl p-5" data-id="element-2416">
              <div className="flex items-center gap-3 mb-3" data-id="element-2417">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-2418">
                  <Lock className="w-5 h-5 text-blue-600" data-id="element-2419" />
                </div>
                <div data-id="element-2420">
                  <h3 className="font-bold text-neutral-text" data-id="element-2421">
                    Public Project Information
                  </h3>
                  <p className="text-xs text-gray-600" data-id="element-2422">
                    Get accredited by the developer to access pricing and
                    detailed units
                  </p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-2423">
                {publicUnitTypes.map((unitType, index) => <div key={index} className="bg-white rounded-xl p-4 border border-blue-100" data-id="element-2424">
                    <div className="flex items-center justify-between mb-2" data-id="element-2425">
                      <h4 className="font-bold text-neutral-text" data-id="element-2426">
                        {unitType.type}
                      </h4>
                      <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-2427">
                        {unitType.count} units available
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mb-3" data-id="element-2428">
                      {unitType.features}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-2429">
                      <Lock className="w-3 h-3" data-id="element-2430" />
                      <span data-id="element-2431">Pricing available for members</span>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="bg-white border-2 border-blue-200 rounded-2xl p-6" data-id="element-2432">
              <h4 className="font-bold text-neutral-text mb-3 text-center" data-id="element-2433">
                Get Accredited
              </h4>
              <p className="text-sm text-gray-600 text-center mb-4" data-id="element-2434">
                Request accreditation from{' '}
                <span className="font-semibold" data-id="element-2435">{project.developer.name}</span>{' '}
                to access pricing, detailed units, and exclusive features
              </p>
              <button onClick={() => {
            setAccreditationMessage('We are Xbeng brokerages and would like to Reprint your project.\nThanks.');
            setShowAccreditationRequestModal(true);
          }} className="w-full bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-bold py-4 rounded-xl transition-colors shadow-lg" data-id="element-2436">
                Request Accreditation
              </button>
            </div>
          </div> : developerTier === 'bronze' ?
      // Bronze Member View - Unit Type Summary Only
      <div className="px-6 pt-5 space-y-4" data-id="element-2437">
            <div className="bg-gradient-to-r from-orange-50 to-amber-50 border-2 border-orange-200 rounded-2xl p-5" data-id="element-2438">
              <div className="flex items-center gap-3 mb-3" data-id="element-2439">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-2440">
                  <Lock className="w-5 h-5 text-orange-600" data-id="element-2441" />
                </div>
                <div data-id="element-2442">
                  <h3 className="font-bold text-neutral-text" data-id="element-2443">
                    Available Unit Types
                  </h3>
                  <p className="text-xs text-gray-600" data-id="element-2444">
                    Detailed units available for Silver & Gold members
                  </p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-2445">
                {unitTypeSummary.map((summary, index) => <div key={index} className="bg-white rounded-xl p-4 border border-orange-100" data-id="element-2446">
                    <div className="flex items-center justify-between mb-2" data-id="element-2447">
                      <h4 className="font-bold text-neutral-text" data-id="element-2448">
                        {summary.type}
                      </h4>
                      <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-2449">
                        {summary.count} units
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mb-3" data-id="element-2450">
                      Price Range:{' '}
                      <span className="font-semibold text-neutral-text" data-id="element-2451">
                        {summary.priceRange}
                      </span>
                    </p>
                    <button onClick={() => setShowLockedUnitsModal(true)} className="w-full bg-gray-100 text-gray-600 font-semibold py-2.5 rounded-lg text-sm flex items-center justify-center gap-2" data-id="element-2452">
                      <Lock className="w-4 h-4" data-id="element-2453" />
                      View Detailed Units
                    </button>
                  </div>)}
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold py-4 rounded-xl transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-2454">
              <Lock className="w-5 h-5" data-id="element-2455" />
              Unlock Full Unit Details
            </div>
          </div> :
      // Silver & Gold Member View - Full Unit Details
      <div className="px-6 pt-5 space-y-4" data-id="element-2456">
            {project.units.map(unit => <div key={unit.id} className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm" data-id="element-2457">
                <div className="flex items-start justify-between mb-4" data-id="element-2458">
                  <div className="flex-1" data-id="element-2459">
                    <div className="flex items-center gap-4 mb-3" data-id="element-2460">
                      <span className="font-bold text-neutral-text text-base" data-id="element-2461">
                        {unit.area}
                      </span>
                      <span className="text-sm text-gray-600" data-id="element-2462">
                        {unit.garden}
                      </span>
                    </div>
                    <div className="flex items-center gap-5 mb-3" data-id="element-2463">
                      <div className="flex items-center gap-2 text-gray-600" data-id="element-2464">
                        <Bed className="w-5 h-5" data-id="element-2465" />
                        <span className="text-sm font-medium" data-id="element-2466">
                          {unit.beds} Beds
                        </span>
                      </div>
                      <div className="flex items-center gap-2 text-gray-600" data-id="element-2467">
                        <Bath className="w-5 h-5" data-id="element-2468" />
                        <span className="text-sm font-medium" data-id="element-2469">
                          {unit.baths} bath.
                        </span>
                      </div>
                    </div>
                    <p className="font-bold text-neutral-text text-lg" data-id="element-2470">
                      {unit.price}
                    </p>
                  </div>
                </div>

                <div className="flex gap-3" data-id="element-2471">
                  <button onClick={() => handleViewPaymentPlan(unit)} className={`flex-1 font-bold px-4 py-3 rounded-xl transition-colors text-sm flex items-center justify-center gap-2 ${developerTier === 'gold' ? 'bg-white border-2 border-secondary text-secondary hover:bg-secondary/5' : 'bg-gray-100 border-2 border-gray-300 text-gray-400 cursor-not-allowed'}`} data-id="element-2472">
                    {developerTier !== 'gold' && <Lock className="w-4 h-4" data-id="element-2473" />}
                    Share Official Offer
                  </button>
                  <button onClick={() => handleSendRMI(unit)} className="flex-1 bg-accent hover:bg-accent-dark text-primary font-bold px-4 py-3 rounded-xl transition-colors text-sm shadow-sm" data-id="element-2474">
                    Send RMI
                  </button>
                </div>
              </div>)}
          </div>}

        {/* Project Description */}
        <div className="px-6 pt-8" data-id="element-2475">
          <h3 className="text-lg font-bold text-neutral-text mb-4" data-id="element-2476">
            Project Description
          </h3>
          <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm" data-id="element-2477">
            <p className="text-sm text-gray-600 leading-relaxed mb-3" data-id="element-2478">
              {project.description}
            </p>
            <button className="text-sm font-bold text-secondary hover:text-secondary-dark" data-id="element-2479">
              View more
            </button>
          </div>
        </div>

        {/* Master Plan */}
        <div className="px-6 pt-8" data-id="element-2480">
          <h3 className="text-lg font-bold text-neutral-text mb-4" data-id="element-2481">
            Master Plan
          </h3>
          <div className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm" data-id="element-2482">
            <img src={project.masterPlan} alt="Master Plan" className="w-full h-72 object-cover" data-id="element-2483" />
          </div>
        </div>

        {/* Amenities */}
        <div className="px-6 pt-8 pb-8" data-id="element-2484">
          <h3 className="text-lg font-bold text-neutral-text mb-4" data-id="element-2485">
            Amenities
          </h3>
          <div className="grid grid-cols-3 gap-4" data-id="element-2486">
            {project.amenities.map((amenity, index) => <div key={index} className="bg-white rounded-2xl p-4 border border-gray-100 flex flex-col items-center gap-3 shadow-sm" data-id="element-2487">
                <span className="text-3xl" data-id="element-2488">{amenity.icon}</span>
                <span className="text-xs text-gray-600 text-center font-medium" data-id="element-2489">
                  {amenity.name}
                </span>
              </div>)}
          </div>
        </div>

        <BottomNav onNetworkClick={onNetworkClick} onInventoryClick={onInventoryClick} onRMIClick={onRMIClick} data-id="element-2490" />

        {/* Send RMI Modal */}
        {showRMIModal && selectedUnit && <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4" data-id="element-2491">
            <div className="bg-white w-full max-w-md rounded-t-3xl sm:rounded-2xl max-h-[85vh] overflow-y-auto" data-id="element-2492">
              <div className="sticky top-0 bg-white px-6 py-4 border-b border-gray-100 flex items-center justify-between" data-id="element-2493">
                <h2 className="text-xl font-bold text-neutral-text" data-id="element-2494">
                  Send New Request
                </h2>
                <button onClick={() => setShowRMIModal(false)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-neutral-bg rounded-full transition-colors" data-id="element-2495">
                  <X className="w-5 h-5" data-id="element-2496" />
                </button>
              </div>

              <div className="p-6 space-y-4" data-id="element-2497">
                {/* Agent Card */}
                <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-xl p-4" data-id="element-2498">
                  <div className="flex items-center justify-between" data-id="element-2499">
                    <div className="flex items-center gap-3" data-id="element-2500">
                      <img src={project.agent.avatar} alt={project.agent.name} className="w-12 h-12 rounded-full object-cover" data-id="element-2501" />
                      <div data-id="element-2502">
                        <p className="text-xs text-gray-600" data-id="element-2503">
                          {project.agent.title}
                        </p>
                        <p className="font-semibold text-neutral-text" data-id="element-2504">
                          {project.agent.name}
                        </p>
                      </div>
                    </div>
                    <button className="bg-primary text-white font-semibold px-4 py-2 rounded-lg text-sm" data-id="element-2505">
                      Send RMI
                    </button>
                  </div>
                </div>

                {/* Unit Info Card */}
                <div className="bg-neutral-bg rounded-xl p-4" data-id="element-2506">
                  <div className="flex gap-3" data-id="element-2507">
                    <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-2508">
                      <img src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=200&h=200&fit=crop" alt="Floor plan" className="w-full h-full object-cover rounded-lg" data-id="element-2509" />
                    </div>
                    <div className="flex-1" data-id="element-2510">
                      <h3 className="font-bold text-neutral-text mb-1" data-id="element-2511">
                        {project.name}
                      </h3>
                      <p className="text-sm text-gray-600 mb-2" data-id="element-2512">
                        {selectedUnit.type}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-gray-600" data-id="element-2513">
                        <span data-id="element-2514">{selectedUnit.baths} Bath</span>
                        <span data-id="element-2515">{selectedUnit.beds} Beds</span>
                      </div>
                      <p className="font-bold text-neutral-text mt-1" data-id="element-2516">
                        {selectedUnit.price}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Message Input */}
                <div data-id="element-2517">
                  <textarea value={rmiMessage} onChange={e => setRmiMessage(e.target.value)} placeholder="I want more information about this unit" rows={6} className="w-full px-4 py-3 border-2 border-secondary rounded-xl focus:ring-2 focus:ring-secondary/20 focus:border-secondary resize-none text-sm" data-id="element-2518" />
                </div>

                {/* Tags */}
                <div className="flex flex-wrap gap-2" data-id="element-2519">
                  {availableTags.map(tag => <button key={tag} onClick={() => toggleTag(tag)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all border-2 ${selectedTags.includes(tag) ? 'bg-secondary text-white border-secondary' : 'bg-white text-gray-600 border-gray-300 hover:border-secondary'}`} data-id="element-2520">
                      {tag}
                    </button>)}
                </div>

                {/* Send Button */}
                <button onClick={handleSubmitRMI} className="w-full bg-primary hover:bg-primary-dark text-white font-bold py-4 rounded-xl transition-colors text-base" data-id="element-2521">
                  SEND REQUEST
                </button>
              </div>
            </div>
          </div>}

        {/* Success Modal */}
        {showSuccessModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2522">
            <div className="bg-white w-full max-w-sm rounded-2xl shadow-xl p-8 text-center" data-id="element-2523">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2524">
                <CheckCircle className="w-12 h-12 text-green-600" data-id="element-2525" />
              </div>
              <h3 className="text-2xl font-bold text-neutral-text mb-2" data-id="element-2526">
                Sent
              </h3>
              <p className="text-gray-600 mb-1" data-id="element-2527">
                We will you know when get Reply
              </p>
              <p className="text-gray-600 mb-6" data-id="element-2528">
                From{' '}
                <span className="font-bold text-neutral-text" data-id="element-2529">
                  {project.developer.name}
                </span>
              </p>

              {/* Progress Tracker */}
              <div className="mb-8" data-id="element-2530">
                <div className="flex items-center justify-between mb-2" data-id="element-2531">
                  <div className="flex flex-col items-center" data-id="element-2532">
                    <div className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center mb-1" data-id="element-2533">
                      <CheckCircle className="w-6 h-6 text-white" data-id="element-2534" />
                    </div>
                    <span className="text-xs font-medium text-neutral-text" data-id="element-2535">
                      Sent
                    </span>
                  </div>
                  <div className="flex-1 h-0.5 bg-gray-200 mx-2" data-id="element-2536"></div>
                  <div className="flex flex-col items-center" data-id="element-2537">
                    <div className="w-10 h-10 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center mb-1" data-id="element-2538"></div>
                    <span className="text-xs text-gray-400" data-id="element-2539">In progress</span>
                  </div>
                  <div className="flex-1 h-0.5 bg-gray-200 mx-2" data-id="element-2540"></div>
                  <div className="flex flex-col items-center" data-id="element-2541">
                    <div className="w-10 h-10 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center mb-1" data-id="element-2542"></div>
                    <span className="text-xs text-gray-400" data-id="element-2543">X</span>
                  </div>
                  <div className="flex-1 h-0.5 bg-gray-200 mx-2" data-id="element-2544"></div>
                  <div className="flex flex-col items-center" data-id="element-2545">
                    <div className="w-10 h-10 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center mb-1" data-id="element-2546"></div>
                    <span className="text-xs text-gray-400" data-id="element-2547">Done</span>
                  </div>
                </div>
              </div>

              <button onClick={handleCloseSuccess} className="w-full bg-secondary hover:bg-secondary-dark text-white font-semibold py-3 rounded-lg transition-colors" data-id="element-2548">
                Close
              </button>
            </div>
          </div>}

        {/* Payment Plan Modal */}
        {showPaymentPlanModal && selectedUnitForPlan && <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center" data-id="element-2549">
            <div className="bg-white w-full max-w-md rounded-t-3xl sm:rounded-2xl max-h-[85vh] overflow-y-auto" data-id="element-2550">
              <div className="sticky top-0 bg-white px-6 py-4 border-b border-gray-100 flex items-center justify-between" data-id="element-2551">
                <h2 className="text-xl font-bold text-neutral-text" data-id="element-2552">
                  Official Offer
                </h2>
                <button onClick={() => setShowPaymentPlanModal(false)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-neutral-bg rounded-full transition-colors" data-id="element-2553">
                  <X className="w-5 h-5" data-id="element-2554" />
                </button>
              </div>

              <div className="p-6 space-y-6" data-id="element-2555">
                {/* Unit Info */}
                <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-xl p-4 border border-teal-100" data-id="element-2556">
                  <div className="flex items-center gap-3 mb-3" data-id="element-2557">
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center" data-id="element-2558">
                      <Home className="w-6 h-6 text-secondary" data-id="element-2559" />
                    </div>
                    <div data-id="element-2560">
                      <h3 className="font-bold text-neutral-text" data-id="element-2561">
                        {selectedUnitForPlan.type}
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-2562">{project.name}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-gray-600 mb-2" data-id="element-2563">
                    <span data-id="element-2564">{selectedUnitForPlan.area}</span>
                    <span data-id="element-2565">•</span>
                    <span data-id="element-2566">{selectedUnitForPlan.beds} Beds</span>
                    <span data-id="element-2567">•</span>
                    <span data-id="element-2568">{selectedUnitForPlan.baths} Baths</span>
                  </div>
                  <p className="text-xl font-bold text-neutral-text" data-id="element-2569">
                    {selectedUnitForPlan.price}
                  </p>
                </div>

                {/* Payment Plans */}
                <div data-id="element-2570">
                  <h3 className="font-bold text-neutral-text mb-3" data-id="element-2571">
                    Available Payment Plans
                  </h3>
                  <div className="space-y-3" data-id="element-2572">
                    {project.paymentPlans.map(plan => <div key={plan.id} className="bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-secondary transition-colors cursor-pointer" data-id="element-2573">
                        <div className="flex items-start justify-between mb-2" data-id="element-2574">
                          <h4 className="font-bold text-neutral-text" data-id="element-2575">
                            {plan.duration}
                          </h4>
                          <span className="bg-accent text-primary text-xs font-bold px-3 py-1 rounded-full" data-id="element-2576">
                            Popular
                          </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-1" data-id="element-2577">
                          {plan.downpayment}
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2578">
                          {plan.installments}
                        </p>

                        {/* Sample Calculation */}
                        <div className="mt-3 pt-3 border-t border-gray-100" data-id="element-2579">
                          <div className="flex justify-between text-sm mb-1" data-id="element-2580">
                            <span className="text-gray-600" data-id="element-2581">Down Payment:</span>
                            <span className="font-semibold text-neutral-text" data-id="element-2582">
                              0 EGP
                            </span>
                          </div>
                          <div className="flex justify-between text-sm mb-1" data-id="element-2583">
                            <span className="text-gray-600" data-id="element-2584">Monthly:</span>
                            <span className="font-semibold text-neutral-text" data-id="element-2585">
                              11,117 EGP
                            </span>
                          </div>
                          <div className="flex justify-between text-sm" data-id="element-2586">
                            <span className="text-gray-600" data-id="element-2587">Total:</span>
                            <span className="font-bold text-secondary" data-id="element-2588">
                              1,334,000 EGP
                            </span>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Additional Info */}
                <div className="bg-blue-50 border border-blue-100 rounded-xl p-4" data-id="element-2589">
                  <p className="text-sm text-gray-700 leading-relaxed" data-id="element-2590">
                    <span className="font-semibold" data-id="element-2591">Note:</span> Payment plans
                    are subject to developer approval. Final terms may vary
                    based on unit availability and current promotions.
                  </p>
                </div>

                {/* Action Buttons */}
                <div className="space-y-3" data-id="element-2592">
                  <button onClick={handleSharePaymentPlan} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-2593">
                    <MessageCircle className="w-5 h-5" data-id="element-2594" />
                    Share via WhatsApp
                  </button>
                  <button onClick={() => {
                setShowPaymentPlanModal(false);
                handleSendRMI(selectedUnitForPlan);
              }} className="w-full bg-secondary hover:bg-secondary-dark text-white font-bold py-4 rounded-xl transition-colors" data-id="element-2595">
                    Request More Info
                  </button>
                </div>
              </div>
            </div>
          </div>}

        {/* Locked Feature Modal */}
        {showLockedFeatureModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2596">
            <div className="bg-white w-full max-w-sm rounded-2xl shadow-xl p-8 text-center" data-id="element-2597">
              <div className="w-20 h-20 bg-gradient-to-br from-yellow-100 to-yellow-200 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2598">
                <Lock className="w-10 h-10 text-yellow-600" data-id="element-2599" />
              </div>
              <h3 className="text-2xl font-bold text-neutral-text mb-2" data-id="element-2600">
                Gold Member Feature
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-2601">
                Share Official Offer is exclusively available for{' '}
                <span className="font-bold text-yellow-600" data-id="element-2602">Gold Member</span>{' '}
                developers. Upgrade your partnership to access this premium
                feature.
              </p>

              <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border-2 border-yellow-200 rounded-xl p-4 mb-6" data-id="element-2603">
                <p className="text-sm font-semibold text-yellow-800 mb-2" data-id="element-2604">
                  Gold Member Benefits:
                </p>
                <ul className="text-xs text-gray-700 space-y-1 text-left" data-id="element-2605">
                  <li data-id="element-2606">✓ Share official payment plans</li>
                  <li data-id="element-2607">✓ Access exclusive offers</li>
                  <li data-id="element-2608">✓ Priority support</li>
                  <li data-id="element-2609">✓ Advanced analytics</li>
                </ul>
              </div>

              <button onClick={() => setShowLockedFeatureModal(false)} className="w-full bg-secondary hover:bg-secondary-dark text-white font-semibold py-3 rounded-lg transition-colors" data-id="element-2610">
                Got it
              </button>
            </div>
          </div>}

        {/* Locked Units Modal (for Bronze members) */}
        {showLockedUnitsModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2611">
            <div className="bg-white w-full max-w-sm rounded-2xl shadow-xl p-8 text-center" data-id="element-2612">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-100 to-amber-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2613">
                <Lock className="w-10 h-10 text-orange-600" data-id="element-2614" />
              </div>
              <h3 className="text-2xl font-bold text-neutral-text mb-2" data-id="element-2615">
                Silver & Gold Feature
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-2616">
                Detailed unit listings with specifications and pricing are
                available for{' '}
                <span className="font-bold text-orange-600" data-id="element-2617">Silver</span> and{' '}
                <span className="font-bold text-yellow-600" data-id="element-2618">Gold</span> member
                developers.
              </p>

              <div className="space-y-3 mb-6" data-id="element-2619">
                <div className="bg-gradient-to-r from-gray-50 to-slate-50 border-2 border-gray-200 rounded-xl p-4" data-id="element-2620">
                  <div className="flex items-center gap-2 mb-2" data-id="element-2621">
                    <div className="w-6 h-6 bg-gray-400 rounded-full flex items-center justify-center" data-id="element-2622">
                      <span className="text-white text-xs font-bold" data-id="element-2623">S</span>
                    </div>
                    <p className="text-sm font-bold text-gray-700" data-id="element-2624">
                      Silver Member
                    </p>
                  </div>
                  <ul className="text-xs text-gray-600 space-y-1 text-left" data-id="element-2625">
                    <li data-id="element-2626">✓ View all unit details</li>
                    <li data-id="element-2627">✓ Access unit specifications</li>
                    <li data-id="element-2628">✓ Send RMI requests</li>
                  </ul>
                </div>

                <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border-2 border-yellow-200 rounded-xl p-4" data-id="element-2629">
                  <div className="flex items-center gap-2 mb-2" data-id="element-2630">
                    <div className="w-6 h-6 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center" data-id="element-2631">
                      <span className="text-white text-xs font-bold" data-id="element-2632">G</span>
                    </div>
                    <p className="text-sm font-bold text-yellow-800" data-id="element-2633">
                      Gold Member
                    </p>
                  </div>
                  <ul className="text-xs text-gray-700 space-y-1 text-left" data-id="element-2634">
                    <li data-id="element-2635">✓ All Silver features</li>
                    <li data-id="element-2636">✓ Share official offers</li>
                    <li data-id="element-2637">✓ Access payment plans</li>
                    <li data-id="element-2638">✓ Priority support</li>
                  </ul>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-2639">
                <button onClick={() => setShowLockedUnitsModal(false)} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 rounded-lg transition-colors" data-id="element-2640">
                  Maybe Later
                </button>
                <button onClick={() => {
              setShowLockedUnitsModal(false);
              // Send upgrade request
              const currentTier = developerTier === 'bronze' ? 'Bronze' : 'Silver';
              const targetTier = developerTier === 'bronze' ? 'Silver or Gold' : 'Gold';
              alert(`Upgrade request sent to ${project.developer.name}!\n\nYou are requesting to upgrade from ${currentTier} to ${targetTier} membership.\n\nYou will receive a notification when the developer responds to your request.`);
            }} className="flex-1 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold py-3 rounded-lg transition-colors" data-id="element-2641">
                  Request Upgrade
                </button>
              </div>
            </div>
          </div>}

        {/* Upgrade Modal (for Free tier) */}
        {showUpgradeModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2642">
            <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden" data-id="element-2643">
              <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-6 text-white text-center" data-id="element-2644">
                <h3 className="text-2xl font-bold mb-2" data-id="element-2645">Get Accredited</h3>
                <p className="text-sm opacity-90" data-id="element-2646">
                  Request accreditation from {project.developer.name}
                </p>
              </div>

              <div className="p-6" data-id="element-2647">
                <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-5 mb-6" data-id="element-2648">
                  <div className="flex items-start gap-3 mb-4" data-id="element-2649">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2650">
                      <Lock className="w-5 h-5 text-blue-600" data-id="element-2651" />
                    </div>
                    <div data-id="element-2652">
                      <h4 className="font-bold text-neutral-text mb-1" data-id="element-2653">
                        Not Accredited
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-2654">
                        You are currently viewing public information only. Get
                        accredited by the developer to unlock full access.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-4 mb-6" data-id="element-2655">
                  <h4 className="font-bold text-neutral-text text-center" data-id="element-2656">
                    Accreditation Tiers
                  </h4>
                  <p className="text-sm text-gray-600 text-center" data-id="element-2657">
                    The developer will classify you into one of these tiers
                    based on your partnership level:
                  </p>

                  {/* Bronze Tier */}
                  <div className="border-2 border-orange-200 rounded-xl p-4" data-id="element-2658">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2659">
                      <div className="w-6 h-6 bg-orange-600 rounded-full flex items-center justify-center" data-id="element-2660">
                        <span className="text-white text-xs font-bold" data-id="element-2661">B</span>
                      </div>
                      <h5 className="font-bold text-neutral-text" data-id="element-2662">
                        Bronze Partner
                      </h5>
                    </div>
                    <ul className="text-xs text-gray-600 space-y-1" data-id="element-2663">
                      <li data-id="element-2664">✓ View unit types and price ranges</li>
                      <li data-id="element-2665">✓ Access commission details</li>
                      <li data-id="element-2666">✓ View special offers</li>
                    </ul>
                  </div>

                  {/* Silver Tier */}
                  <div className="border-2 border-gray-300 rounded-xl p-4" data-id="element-2667">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2668">
                      <div className="w-6 h-6 bg-gray-400 rounded-full flex items-center justify-center" data-id="element-2669">
                        <span className="text-white text-xs font-bold" data-id="element-2670">S</span>
                      </div>
                      <h5 className="font-bold text-neutral-text" data-id="element-2671">
                        Silver Partner
                      </h5>
                    </div>
                    <ul className="text-xs text-gray-600 space-y-1" data-id="element-2672">
                      <li data-id="element-2673">✓ All Bronze features</li>
                      <li data-id="element-2674">✓ View detailed unit listings</li>
                      <li data-id="element-2675">✓ Send RMI requests</li>
                      <li data-id="element-2676">✓ Access payment plans</li>
                    </ul>
                  </div>

                  {/* Gold Tier */}
                  <div className="border-2 border-yellow-400 rounded-xl p-4 bg-gradient-to-br from-yellow-50 to-amber-50" data-id="element-2677">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2678">
                      <div className="w-6 h-6 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center" data-id="element-2679">
                        <span className="text-white text-xs font-bold" data-id="element-2680">G</span>
                      </div>
                      <h5 className="font-bold text-neutral-text" data-id="element-2681">
                        Gold Partner
                      </h5>
                    </div>
                    <ul className="text-xs text-gray-700 space-y-1" data-id="element-2682">
                      <li data-id="element-2683">✓ All Silver features</li>
                      <li data-id="element-2684">✓ Share official offers with clients</li>
                      <li data-id="element-2685">✓ Priority support</li>
                      <li data-id="element-2686">✓ Advanced analytics</li>
                    </ul>
                  </div>
                </div>

                <button onClick={() => {
              setShowUpgradeModal(false);
              setAccreditationMessage('We are Xbeng brokerages and would like to Reprint your project.\nThanks.');
              setShowAccreditationRequestModal(true);
            }} className="w-full bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-bold py-4 rounded-xl transition-colors shadow-lg mb-3" data-id="element-2687">
                  Request Accreditation
                </button>
              </div>

              <div className="p-4 border-t border-gray-100" data-id="element-2688">
                <button onClick={() => setShowUpgradeModal(false)} className="w-full text-gray-600 hover:text-gray-800 font-semibold py-2 transition-colors" data-id="element-2689">
                  Maybe Later
                </button>
              </div>
            </div>
          </div>}

        {/* Accreditation Request Modal */}
        {showAccreditationRequestModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" data-id="element-2690">
            <div className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-2xl flex flex-col max-h-[85vh]" data-id="element-2691">
              {/* Header */}
              <div className="flex-shrink-0 px-6 py-4 border-b border-gray-100" data-id="element-2692">
                <h2 className="text-xl font-bold text-neutral-text" data-id="element-2693">
                  Accredited Request
                </h2>
              </div>

              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto p-6 space-y-5" data-id="element-2694">
                {/* Developer Info */}
                <div className="flex items-center gap-4" data-id="element-2695">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-blue-100 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-teal-200" data-id="element-2696">
                    <img src={project.developer.logo} alt={project.developer.name} className="w-10 h-10 object-contain" data-id="element-2697" />
                  </div>
                  <div data-id="element-2698">
                    <h3 className="font-bold text-neutral-text text-base" data-id="element-2699">
                      {project.developer.name}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-2700">
                      Real Estate Developer
                    </p>
                  </div>
                </div>

                {/* Message Input */}
                <div data-id="element-2701">
                  <textarea value={accreditationMessage} onChange={e => setAccreditationMessage(e.target.value)} placeholder="Introduce yourself and explain why you'd like to be accredited..." rows={6} className="w-full px-4 py-3 border-2 border-blue-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 resize-none text-sm text-gray-700" data-id="element-2702" />
                </div>

                {/* Info Box */}
                <div className="bg-blue-50 border border-blue-100 rounded-xl p-4" data-id="element-2703">
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-2704">
                    Your request will be reviewed by the developer's account
                    manager. They will assess your profile and partnership
                    potential before assigning you a membership tier (Bronze,
                    Silver, or Gold).
                  </p>
                </div>
              </div>

              {/* Footer with Button */}
              <div className="flex-shrink-0 p-6 border-t border-gray-100" data-id="element-2705">
                <div className="flex gap-3" data-id="element-2706">
                  <button onClick={() => {
                setShowAccreditationRequestModal(false);
                setAccreditationMessage('');
              }} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold py-4 rounded-xl transition-colors" data-id="element-2707">
                    Cancel
                  </button>
                  <button onClick={() => {
                setShowAccreditationRequestModal(false);
                setShowAccreditationSuccessModal(true);
              }} disabled={!accreditationMessage.trim()} className="flex-1 bg-gradient-to-r from-primary to-primary-dark text-white font-bold py-4 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2708">
                    Proceed Connect
                  </button>
                </div>
              </div>
            </div>
          </div>}

        {/* Accreditation Success Modal */}
        {showAccreditationSuccessModal && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-2709">
            <div className="bg-white w-full max-w-sm rounded-2xl shadow-xl p-8 text-center" data-id="element-2710">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2711">
                <CheckCircle className="w-12 h-12 text-green-600" data-id="element-2712" />
              </div>
              <h3 className="text-2xl font-bold text-neutral-text mb-2" data-id="element-2713">
                Request Sent!
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-2714">
                Your accreditation request has been sent to{' '}
                <span className="font-bold text-neutral-text" data-id="element-2715">
                  {project.developer.name}
                </span>
                . You will receive a notification when they respond.
              </p>

              <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-6" data-id="element-2716">
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-2717">
                  <span className="font-semibold" data-id="element-2718">What's next?</span>
                  <br data-id="element-2719" />
                  The developer's account manager will review your request and
                  may contact you for additional information. Once approved,
                  you'll be assigned a membership tier.
                </p>
              </div>

              <button onClick={() => {
            setShowAccreditationSuccessModal(false);
            setAccreditationMessage('');
          }} className="w-full bg-secondary hover:bg-secondary-dark text-white font-bold py-3 rounded-xl transition-colors" data-id="element-2720">
                Got it
              </button>
            </div>
          </div>}
      </div>
    </div>;
}